import React from 'react';
import { userHasPermission } from 'hooks/useRoles';
import { IRole } from 'shared/models/api/models';

export interface IActionProps {
    name: string,
    icon: any,
    permission: string,
    minSelectedCount?: number,
    maxSelectedCount?: number,
    openView?: string
}

interface IToolbarButtonProps {
    action: IActionProps,
    onClick: (action: IActionProps) => void,
    selectedCount?: number
}

export const ToolbarButton = (props: IToolbarButtonProps) => {
    const Icon = props.action.icon;

    const isEnabled = () => {
        if (props.selectedCount != undefined) {

            if (props.action.minSelectedCount) {
                if (props.selectedCount < props.action.minSelectedCount) {
                    return false;
                }
            }

            if (props.action.maxSelectedCount) {
                if (props.selectedCount > props.action.maxSelectedCount) {
                    return false;
                }
            }

        }

        return true;
    };

    return (
        <div className={"tb-button" + (isEnabled() ? " enabled" : " disabled")} onClick={() => props.onClick(props.action)}>
            <div className="tb-icon center-children-both"><Icon /></div>
            <div className="tb-name center-children-both">{props.action.name}</div>
        </div>
    );
}

interface IToolbarProps {
    actions: IActionProps[],
    userRoles?: IRole[],
    onClick: (action: IActionProps) => void,
    selectedCount?: number
}

export const Toolbar = (props: IToolbarProps) => {
    const userActions = props.actions.filter(action => userHasPermission(action.permission, props.userRoles));

    return (
        <div className="toolbar">
            {userActions.map(action =>
                <ToolbarButton key={action.name} action={action} onClick={props.onClick} selectedCount={props.selectedCount} />
            )}
        </div>);
};